import { NgModule } from '@angular/core';
import { ZoundfxDirective } from './zoundfx.directive';
@NgModule({
  declarations: [ZoundfxDirective],
  exports: [ZoundfxDirective]
})
export class NgZzfxModule { }
